import React, {
    KeyboardEventHandler,
    MouseEventHandler
} from 'react';
import {BoxProps} from '@material-ui/core/Box';
import {useMediaQuery} from '@material-ui/core';

import {TextInputFormControl} from '../../../forms/text-input-form-control/text-input-form-control';
import {ButtonFormControl} from '../../../forms/button-form-control/button-form-control';
import {SearchRequest} from '../../../../api/types/__generated__/data-contracts';
import {YearInputFormControl} from '../../../forms/year-input-form-control/year-input-form-control';
import {HStack, VStack} from '../../../layout/layout.styled';
import {useSearchControls} from './hooks';

type Props = {
    isLoading: boolean
    onSearch: (request: SearchRequest) => any
}

const buttonStackProps: BoxProps = {
    style: {
        fontSize: '18px',
        flexGrow: 1,
        minWidth: '170px'
    }
};

const inputStackProps: BoxProps = {
    style: {
        minWidth: 300
    }
};

export const SearchControls = ({ onSearch, isLoading }: Props) => {
    const {
        onChange, onSubmitSearch
    } = useSearchControls({ onSearch });
    const matches = useMediaQuery('(min-width:844px)');
    const Stack = matches ? HStack : VStack;

    return (
        <Stack spacing={'20px'} data-testid={'SearchControls'}>
            <TextInputFormControl
                data-testid={'SearchSchoolNameOrCRMID'}
                onChange={onChange('term')}
                onEnterKey={onSubmitSearch as KeyboardEventHandler}
                labelText={'Search for School Name Or C3 ID'}
                stackProps={inputStackProps}
            />

            <YearInputFormControl
                data-testid={'SearchAcademicYear'}
                onChange={onChange('academicYear')}
                onEnterKey={onSubmitSearch as KeyboardEventHandler}
                labelText={'Academic Year'}
                stackProps={inputStackProps}
            />

            <ButtonFormControl
                data-testid={'SearchButton'}
                buttonLabelText={'Search'}
                isLoading={isLoading}
                onClick={onSubmitSearch as MouseEventHandler}
                buttonProps={buttonStackProps}
            />
        </Stack>
    );
};
